import React from "react"
import styles from "./index.module.scss"
import { PreLotteryProps } from "@hg/activity-utils"
import Rule from "../components/Rule"
import { i18n } from "@/i18n"

const PreLottery = ({ onConfirm, onClose }: PreLotteryProps) => {
    return (
        <div className={styles.preLottery}>
            <Rule
                open
                onClose={onClose}
                showConfirmBtn
                confirmText={i18n.get("reward.button_draw")}
                onConfirm={onConfirm}
            />
        </div>
    )
}

export default PreLottery
